<template>
    <div>
        <breadcrumb-slot :items="items" :modal="false"></breadcrumb-slot>

        <div class="p-1 d-flex justify-content-between">
            <h2 class="text-dark">კვლევები</h2>

            <b-button variant="primary" class="mb-3" v-b-modal.modal-edit>
                <feather-icon icon="PlusCircleIcon"
                              class="mr-50"/>
                <span class="align-middle">კვლევის დამატება</span>
            </b-button>
        </div>

        <b-modal id="modal-edit"
                 ref="my-modal"
                 size="lg"
                 hide-footer
                 centered>
            <breadcrumb-slot class="mb-2" :items="modalItems" :modal="true"></breadcrumb-slot>

            <b-form class="">
                <div class="d-flex justify-content-between">
                    <b-form-group>
                        <label for="georgian">ქართულად</label>
                        <b-input-group class="input-group-merge">
                            <b-form-input
                                    :class="{'btn-outline-success': editingGeorgian}"
                                    v-model="editGeorgian"
                                    id="georgian"
                                    type="text"
                                    placeholder="ქართულად"/>
                            <b-input-group-append>
                                <b-button variant="outline-secondary" v-if="!editingGeorgian">
                                    <feather-icon icon="Edit3Icon"
                                                  class="cursor-pointer"/>
                                </b-button>

                                <b-button variant="success" v-else>
                                    <feather-icon icon="CheckIcon"
                                                  class="cursor-pointer"/>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>

                    <b-form-group>
                        <label for="english">ინგლისურად</label>
                        <b-input-group class="input-group-merge">
                            <b-form-input
                                    :class="{'btn-outline-success': editingEnglish}"
                                    v-model="editEnglish"
                                    id="english"
                                    type="text"
                                    placeholder="ინგლისურად"/>
                            <b-input-group-append>
                                <b-button variant="outline-secondary" v-if="!editingEnglish">
                                    <feather-icon icon="Edit3Icon"
                                                  class="cursor-pointer"/>
                                </b-button>

                                <b-button variant="success" v-else>
                                    <feather-icon icon="CheckIcon"
                                                  class="cursor-pointer"/>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </div>
            </b-form>

            <p class="mt-2">ქვევარიანტები</p>
            <b-table responsive="sm"
                     :fields="['georgian', 'english', 'actions']"
                      outlined
                     hover
                     show-empty
                     empty-text="ვარიანტები არ არის დამატებული"
                     :items="subvariants">
                <template #cell(actions) td-class="text-right">
                    <b-button variant="flat-secondary" class="btn-icon">
                        <feather-icon icon="Edit3Icon"/>
                    </b-button>
                    <b-button variant="flat-danger" class="btn-icon">
                        <feather-icon icon="Trash2Icon"/>
                    </b-button>
                </template>
            </b-table>
            <b-input-group-prepend></b-input-group-prepend>

            <b-form class="append-variant" v-if="newVariantVisible">
                <b-form-group>
                    <b-input-group class="input-group-merge">
                        <b-form-input class="btn-outline-success"
                                      v-model="addGeorgian"
                                      id="variantGeorgian"
                                      type="text"
                                      placeholder="ქართულად"/>
                        <b-form-input
                                class="btn-outline-success"
                                v-model="addEnglish"
                                id="variantEnglish"
                                type="text"
                                placeholder="ინგლისურად"/>
                        <b-input-group-append>
                            <b-button variant="success">
                                <feather-icon icon="SaveIcon"
                                              class="cursor-pointer"/>
                                <span class="ml-1 align-middle">შენახვა</span>

                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-form>

            <b-button class="add-subvariant btn-flat-dark mb-3" v-if="!newVariantVisible" @click="newVariantVisible = true">
                <feather-icon icon="PlusIcon"
                              class="mr-50"/>
                <span class="align-middle">ახალი ქვევარიანტი</span>
            </b-button>


            <div class="d-flex justify-content-between align-items-center">

                <b-button variant="flat-danger" class="mb-3" v-if="!newVariantVisible" @click="hideModal">
                    <feather-icon icon="Trash2Icon"
                                  class="mr-50"/>
                    <span class="align-middle">ვარიანტის წაშლა</span>
                </b-button>


                <b-button variant="primary" class="mb-3" v-if="!newVariantVisible" @click="hideModal">
                    <feather-icon icon="SaveIcon"
                                  class="mr-50"/>
                    <span class="align-middle">ცვლილებების შენახვა</span>
                </b-button>
            </div>
        </b-modal>

        <table-basic-analisys :title="'ნაცხი'" :rows="rows" :columns="columns"></table-basic-analisys>
        <table-basic-analisys :title="'ნაცხი'" :rows="rows" :columns="columns"></table-basic-analisys>
        <table-basic-analisys :title="'ნაცხი'" :rows="rows" :columns="columns"></table-basic-analisys>
        <table-basic-analisys :title="'ნაცხი'" :rows="rows" :columns="columns"></table-basic-analisys>
    </div>
</template>

<script>
    import BreadcrumbSlot from "../components/breadcrumb/BreadcrumbSlot";
    import {
        BButton,
        BModal,
        BForm,
        BTable,
        BFormGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroupPrepend,
        BInputGroup
    } from "bootstrap-vue"
    import TableBasicAnalisys from "../table/bs-table/TableBasicAnalisys";

    export default {
        name: "Analysis",
        components: {
            TableBasicAnalisys,
            BreadcrumbSlot,
            BButton,
            BModal,
            BForm,
            BTable,
            BFormGroup,
            BFormInput,
            BInputGroupAppend,
            BInputGroup,
            BInputGroupPrepend
        },
        data() {
            return {
                items: [
                    {
                        text: "ცვლადები",
                        active: true
                    }
                ],
                modalItems: [
                    {
                        text: "კვლევები",
                    },
                    {
                        text: "GeneXpert",
                    },
                    {
                        text: "MTB გამოვლინდა",
                        active: true
                    }
                ],
                rows: [
                    {
                        id: 1,
                        georgian: "ხველა",
                        english: "coughing",
                        default: false
                    },
                    {
                        id: 2,
                        georgian: "ხველა",
                        english: "coughing",
                        default: false
                    },
                    {
                        id: 3,
                        georgian: "ხველა",
                        english: "coughing",
                        default: false
                    },
                    {
                        id: 4,
                        georgian: "ხველა",
                        english: "coughing",
                        default: false
                    },
                ],
                subvariants: [
                    {
                        id: 1,
                        georgian: "რიფამპიცინის მიმართ რეზისტენტული",
                        english: "Resistant against Riphamicyne",
                        default: false
                    },
                    {
                        id: 2,
                        georgian: "რიფამპიცინის მიმართ სენსიტიური",
                        english: "Sensitive against Riphamicyne",
                        default: false
                    },
                    {
                        id: 3,
                        georgian: "რიფამპიცინის მიმართ რეზისტენტობა არ განისაზღვრა",
                        english: "Resistency against Riphamicyne was not defined",
                        default: false
                    }
                ],
                columns: [
                    {
                        key: "georgian",
                        label: "ქართული",
                        sortable: true
                    },
                    {
                        key: "english",
                        label: "ინგლისური",
                        sortable: true
                    },
                    {
                        key: "actions",
                        label: "",
                    },
                ],
                editGeorgian: "",
                editEnglish: "",
                editingEnglish: false,
                editingGeorgian: false,
                addGeorgian: "",
                addEnglish: "",
                newVariantVisible: false
            }
        },

        watch: {
            editGeorgian: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.editingGeorgian = true;
                }
            },
            editEnglish: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.editingEnglish = true;
                }
            }
        },

        methods: {
            hideModal() {
                this.$refs["my-modal"].hide()
            }
        }
    }
</script>

<style scoped>

    #modal-edit .form-group {
        width: 45%;
    }

    .append-variant .form-group {
        width: 100%;
    }

    .append-variant #variantGeorgian {
        border-right: none !important;
    }

    .append-variant #variantEnglish {
        border-left: none !important;
        padding-left: 15px;
    }

    #modal-edit .table-responsive-sm .table td[aria-colindex='3'] {
        white-space: nowrap;
    }

    .add-subvariant {
        width: 100%;
    }
</style>
